<template>
  <v-container>
    <h1>Setup</h1>
    <component :is="currentComponent" :showGender="true"></component>
  </v-container>
</template>

<script>
import SetupChurchMember from '../setup-church-member'

export default {
  data: () => ({
    accountType: 'church-member'
  }),
  computed: {
    currentComponent: function () {
      if (this.accountType === null) {
        return null
      } else {
        return 'setup-' + this.accountType
      }
    }
  },
  mounted () {
    // Make sure we're supposed to be here (i.e., we haven't already completed
    // basic setup)
    if (this.$auth.user().roles !== null) {
      this.$router.push('/')
    }
  },
  components: {
    SetupChurchMember
  }
}
</script>
